var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "page-platformList" },
      [
        _c("v-container", [
          _c("div", { staticClass: "page-platformList__title" }, [
            _c("i", { staticClass: "icon-icon-providers" }),
            _c("div", { staticClass: "text" }, [
              _c("h1", [_vm._v(_vm._s(_vm.$t("front.provider.page.title")))]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("front.provider.page.description")))
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "page-platformList__list" },
            _vm._l(_vm.platforms, function(item, index) {
              return _c("div", { key: index, staticClass: "item" }, [
                _c("div", { staticClass: "item__box" }, [
                  _c(
                    "div",
                    { staticClass: "item__image" },
                    [
                      _c("router-link", { attrs: { to: item.pageUrl } }, [
                        _c(
                          "picture",
                          [
                            _vm._l(item.logo.sourcesTypes, function(
                              sourceType,
                              index
                            ) {
                              return _c("source", {
                                key: index,
                                attrs: {
                                  srcset: item.logo[sourceType],
                                  type: "image/" + sourceType
                                }
                              })
                            }),
                            _c("img", {
                              attrs: { src: item.logo.jpg, alt: item.title }
                            })
                          ],
                          2
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item__content" },
                    [
                      _c("div", { staticClass: "item__content-inf" }, [
                        _c("h2", {
                          domProps: { textContent: _vm._s(item.title) }
                        }),
                        _c(
                          "div",
                          { staticClass: "rate" },
                          _vm._l(5, function(index) {
                            return _c("img", {
                              attrs: {
                                src: _vm.itemRatingImage(item, index),
                                alt: "rating"
                              }
                            })
                          }),
                          0
                        )
                      ]),
                      _c(
                        "router-link",
                        {
                          staticClass: "read-btn",
                          attrs: { to: item.pageUrl }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("front.provider.button.read_more")
                              ) +
                              "\n                            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            }),
            0
          ),
          _vm.hasMorePlatforms
            ? _c(
                "div",
                { staticClass: "page-platformList__load" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { loading: _vm.morePlatformsLoading },
                      on: { click: _vm.showMorePlatforms }
                    },
                    [_vm._v(_vm._s(_vm.$t("front.provider.button.load_more")))]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }